import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '../auth';

export function Admin() {
  const { user } = useAuth();

  // Проверяем, что пользователь - администратор
  if (!user || user.role !== 'Администратор') {
    return (
      <div className="container mx-auto max-w-7xl">
        <div className="text-center py-8">
          <h1 className="text-2xl font-bold text-red-600">Доступ запрещен</h1>
          <p className="text-muted-foreground mt-2">
            Эта страница доступна только администраторам
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto max-w-7xl">
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Панель администратора</h1>
          <p className="text-muted-foreground mt-2">
            Управление системой и пользователями
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {/* Управление пользователями */}
          <Card className="cursor-pointer hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle>Пользователи</CardTitle>
              <CardDescription>Управление пользователями системы</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <p className="text-sm text-muted-foreground">
                  Просмотр и редактирование
                </p>
                <Button className="w-full" asChild>
                  <Link to="/admin/users">Управление пользователями</Link>
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Платежи */}
          <Card className="cursor-pointer hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle>Платежи</CardTitle>
              <CardDescription>Управление платежами и транзакциями</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <p className="text-sm text-muted-foreground">
                  Просмотр и подтверждение платежей
                </p>
                <Button className="w-full" asChild>
                  <Link to="/admin/payments">Управление платежами</Link>
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Настройки системы */}
          <Card className="cursor-pointer hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle>Настройки</CardTitle>
              <CardDescription>Конфигурация системы</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <p className="text-sm text-muted-foreground">
                  Курсы валют, индексы поиска, IP исключения
                </p>
                <Button className="w-full" asChild>
                  <Link to="/admin/settings">Настройки системы</Link>
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Статистика */}
          <Card className="cursor-pointer hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle>Статистика</CardTitle>
              <CardDescription>Аналитика и метрики</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <p className="text-sm text-muted-foreground">
                  Производительность поиска
                </p>
                <Button className="w-full" asChild>
                  <Link to="/admin/statistics">Просмотр статистики</Link>
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Telegram аккаунты */}
          <Card className="cursor-pointer hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle>Telegram аккаунты</CardTitle>
              <CardDescription>Управление Telegram аккаунтами</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <p className="text-sm text-muted-foreground">
                  Статистика и управление Telegram аккаунтами
                </p>
                <Button className="w-full" asChild>
                  <Link to="/admin/telegram">Управление аккаунтами</Link>
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* IP исключения */}
          <Card className="cursor-pointer hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle>IP исключения</CardTitle>
              <CardDescription>Управление IP исключениями</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <p className="text-sm text-muted-foreground">
                  Настройка IP адресов для обхода Turnstile
                </p>
                <Button className="w-full" asChild>
                  <Link to="/admin/ip-exceptions">Управление IP</Link>
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Индексы Elasticsearch */}
          <Card className="cursor-pointer hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle>Индексы</CardTitle>
              <CardDescription>Управление индексами Elasticsearch</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <p className="text-sm text-muted-foreground">
                  Добавление, отключение и удаление индексов поиска
                </p>
                <Button className="w-full" asChild>
                  <Link to="/admin/indices">Управление индексами</Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );

}
